import React from 'react'

function SendReports() {
    return (
        <div>SendReports</div>
    )
}

export default SendReports